module.exports = {"current_context":"contextSupplierCoC","current_progress":"progressSupplierCoC","categories":[{"cat":"transport"},{"cat":"other"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/context.json
// module id = lEEI
// module chunks = 6